import { IRecommendations } from '../../../types/newbuildingRecommendations';
import { TBanners } from '../../../types/newbuildingBanners/banners';

const banners = ['lastChanceDiscount', 'topPromos', 'topPromo', 'allPromos', 'newbuildingBroker', 'marketing'];

export const isNewbuildingBanner = (item: IRecommendations | TBanners): item is TBanners => {
  return !!(item.type && banners.includes(item.type));
};
